<header role="banner" class="form-input__header">
  <p *ngIf="question.title" class="form-input__header__title" [innerHTML]="title"></p>
  <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
</header>

<app-ui-file-picker
  class="file"
  name="logo"
  [accept]="acceptList"
  [formControl]="control"
  [maxSize]="2"
  caption="Glisser ou sélectionner votre fichier ici"
></app-ui-file-picker>

<footer class="form-input__actions">
  <button
    class="btn"
    type="button"
    (click)="next(control)"
    [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
  >
    Valider
  </button>
  <button
    *ngIf="!required"
    class="btn-clean"
    type="button"
    (click)="skipQuestion.emit(control)"
    [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
  >
    Passer
  </button>
</footer>
